import React from 'react';
import { useTranslation } from 'react-i18next';
import { BdsIcon, BdsDivider } from '@/core/constants/webComponents';
import './HashtagsModal.scss';

interface HashtagsModalProps {
  hashtags: string[];
  onClose: () => void;
  onHashtagClick: (tag: string, index: number) => void;
}

export const HashtagsModal: React.FC<HashtagsModalProps> = ({
  hashtags,
  onClose,
  onHashtagClick,
}) => {
  const { t } = useTranslation();

  return (
    <div 
      className="hashtags-modal-overlay" 
      onClick={onClose} 
      onKeyDown={(e) => e.key === 'Escape' && onClose()}
      role="presentation"
    >
      <dialog 
        open
        className="hashtags-modal-container" 
        aria-labelledby="hashtags-modal-title"
      >
        <div
          role="none"
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <div className="hashtags-modal-header">
            <h2 id="hashtags-modal-title" className="hashtags-modal-title">
              {t('cardPosts.allHashtagsTitle')}
            </h2>
            <button 
              type="button" 
              className="hashtags-modal-close" 
              onClick={onClose}
              aria-label={t('cardPosts.close') ?? 'Close'}
            >
              <BdsIcon name="close" size="small" />
            </button>
          </div>
          <BdsDivider />
          <div className="hashtags-modal-body">
            <div className="hashtags-modal-list">
              {hashtags.map((tag, index) => (
                <button
                  key={`${tag}-${index}`}
                  type="button"
                  className="hashtags-modal-item"
                  onClick={() => {
                    onHashtagClick(tag, index);
                    onClose();
                  }}
                >
                  {tag}
                </button>
              ))}
            </div>
          </div>
        </div>
      </dialog>
    </div>
  );
};
